import { useMemo } from 'react';
import { selectPromptTemplates, selectSelectedTemplateAction, selectedPromptTemplate } from '../selectors/promptTemplateSelectors';
import { useSelector } from 'react-redux';
import { createPromptTemplate } from 'chatspot-core/messageActions/createPromptTemplate';
export const useSelectedPromptTemplate = () => {
  const promptTemplates = useSelector(selectPromptTemplates);
  const selectedPromptTemplateId = useSelector(selectedPromptTemplate);
  const selectedTemplateAction = useSelector(selectSelectedTemplateAction);
  return useMemo(() => {
    if (selectedTemplateAction) {
      // Create a "mock" Prompt Template for us to fill in based on the template
      // button
      return createPromptTemplate(selectedTemplateAction);
    }
    if (selectedPromptTemplateId === undefined || selectedPromptTemplateId === null) {
      return undefined;
    }
    return promptTemplates.find(template => template.id === selectedPromptTemplateId);
  }, [promptTemplates, selectedPromptTemplateId, selectedTemplateAction]);
};